<app-title-bar titleText="i18n.base.set-password.header"></app-title-bar>
<div class="row">
  <div class="col-lg-4 offset-lg-4 col-md-6 offset-md-3">
    <form [formGroup]="setPasswordForm"
          *ngIf="areParametersValid && !passwordSetSuccess">
      <div class="form-group">
        <label for="password"
               class="required">{{ "i18n.base.set-password.password" | translate }}</label>
        <input id="password"
               type="password"
               class="form-control"
               formControlName="password"
               appPasswordVisibility>
        <app-error-messages [control]="formFields.password"></app-error-messages>
      </div>
      <div class="form-group">
        <label for="passwordConfirm"
               class="required">{{ "i18n.base.set-password.passwordConfirm" | translate }}</label>
        <input id="passwordConfirm"
               type="password"
               class="form-control"
               formControlName="passwordConfirm"
               appPasswordVisibility>
        <app-error-messages [control]="formFields.passwordConfirm"></app-error-messages>
      </div>

      <div *ngIf="setPasswordForm.errors?.passwordConfirmationMismatch" class="text-danger mb-2">
        {{'i18n.core.messages.changePassword.pwdDoNotMatch' | translate}}
      </div>

      <button type="submit"
              class="btn btn-primary"
              (click)="setPassword()"
              [disabled]="!setPasswordForm.valid">
        {{ "i18n.base.set-password.setPassword" | translate }}
      </button>
    </form>
    <div *ngIf="!areParametersValid">
      {{ "i18n.base.set-password.invalid-link" | translate }}
    </div>
    <div *ngIf="passwordSetSuccess">
      <div>
        <p class="success-message">
          <span class="e-icons icon-checkmark me-1"></span>{{ "i18n.base.set-password.success-message" | translate }}</p>
        <p class="success-message">{{autoRedirectMessage}}</p>
        <a [routerLink]="[loginRoute]">{{ 'i18n.core.navigation.login' | translate }}</a>
      </div>
    </div>
  </div>
</div>
